module.exports = __webpack_public_path__ + "img/img20.0d3bc722.svg";